eshopApp.controller('QuickLoginController', ['$scope', '$http', '$rootScope', function($scope, $http, $rootScope){
    
    $rootScope.m_QuickLogin = true;

}]);